<template>
  <div class="link-box" :class="{'hidden': type == 0}">
    <template v-if="type > 0">
      <transition name="blink">
        <div class="text-box" v-if="type == 1" key="A">
          已有账号?
          <router-link class="link" :to="{name:'login', query:$route.query}" replace>返回登录</router-link>
        </div>
        <div class="text-box" v-else-if="type == 2" key="B">
          没有账号?
          <router-link class="link" :to="{name:'signup', query:$route.query}" replace>立即注册</router-link>
        </div>
        <div class="text-box" v-else-if="type == 3" key="C">
          想起密码?
          <router-link class="link" :to="{name:'login', query:$route.query}" replace>返回登录</router-link>
        </div>
        <div class="text-box" v-else-if="type == 4" key="D">
          暂不同意?
          <span class="link" @click="$emit('update', 'loginP')">返回登录</span>
        </div>
      </transition>
    </template>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    type: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.link-box {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  border-radius: 0 0 6px 6px;
  background-color: #f6f6f6;
  transition: opacity 0.2s ease-out;

  &.hidden {
    opacity: 0;
  }

  .blink-enter-active {
    transition: opacity 0.2s ease-out;
  }

  .blink-leave-active {
    transition: opacity 0.2s ease-out;
  }

  .blink-enter,
  .blink-leave-to {
    opacity: 0;
  }
  .text-box {
    position: absolute;
    width: 100%;
    text-align: center;
    color: #666;
    .link {
      display: inline-block;
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      color: #666;
      box-sizing: border-box;
      border-bottom: solid 1px transparent;
      transition: border-color 0.12s ease-out;
      cursor: default;

      color: #0081ff;

      &:hover {
        border-color: #0081ff;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/index/components/linkBox.vue